import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { followUser, unfollowUser, getAllUsers } from "../utils/api";

export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
  return await getAllUsers();
});

export const followUserAsync = createAsyncThunk(
  "users/followUser",
  async ({ followerId, followingId }) => {
    await followUser(followerId, followingId);
    return { followerId, followingId };
  }
);

export const unfollowUserAsync = createAsyncThunk(
  "users/unfollowUser",
  async ({ followerId, followingId }) => {
    await unfollowUser(followerId, followingId);
    return { followerId, followingId };
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    updateUserReducer: (state, action) => {
      state.users = state.users.map((user) =>
        user._id === action.payload.id
          ? { ...user, ...action.payload.updatedUser }
          : user
      );
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })

      .addCase(followUserAsync.fulfilled, (state, action) => {
        const { followerId, followingId } = action.payload;
        state.users = state.users.map((user) => {
          if (user._id === followerId) {
            return { ...user, following: [...user.following, followingId] };
          } else if (user._id === followingId) {
            return { ...user, followers: [...user.followers, followerId] };
          }
          return user;
        });
      })

      .addCase(unfollowUserAsync.fulfilled, (state, action) => {
        const { followerId, followingId } = action.payload;
        state.users = state.users.map((user) => {
          if (user._id === followerId) {
            return {
              ...user,
              following: user.following.filter((id) => id !== followingId),
            };
          } else if (user._id === followingId) {
            return {
              ...user,
              followers: user.followers.filter((id) => id !== followerId),
            };
          }
          return user;
        });
      });
  },
});

export const { updateUserReducer } = usersSlice.actions;
export default usersSlice.reducer;
